import React, { useEffect, useState } from "react";
import { Eye, Star, Trash2 } from "react-feather/dist";
import { Link } from "react-router-dom";
import Select, { SingleValue } from "react-select";
import ImageWithBasePath from "../common/imageWithBasePath";
import { Editor } from "primereact/editor";
import CommonSelect, { Option } from "../common/commonSelect";
import { _get, _post } from "../../feature-module/Utils/Helper";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
// import Subjects from "../../feature-module/academic/class-subject/subjects";

interface SyllabusModalProps {
  selected?: any;
}
const SyllabusModal: React.FC<SyllabusModalProps> = ({ selected }) => {
  const { user, classes, subjects } = useSelector((state: RootState) => state.auth)
  const chooseClass = classes.length ? classes.map((cls: any) => ({ value: cls.class_code || "", label: cls.class_code })) : []
  const _form = {
    query_type: "create",
    user_id: "",
    title: "",
    class_code: "",
    term: "",
    end_date: "",
    subject: "",
    content: "",
    status: "Pending",
    week: "",
    week_label: ""
  }
  const [form, setForm] = useState(_form)

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault(); // This is now correctly typed
    _post('syllabus',
      { ...form, user_id: user.id, created_by: user.name },
      (res) => {
        if (res.success) {
          alert("Created successfully");
        }
      },
      (err) => {
        console.error(err);
      }
    )
  }

  const terms = ['First Term', 'Second Term', 'Third Term'];
  const Weeks = Array.from({ length: 12 }, (_, i) => i + 1);
  const WeekOptions = Weeks.map((item: any) => ({ value: item, label: `Week ${item}` }))
  // const {subjects, classes} = useSelector((state:RootState)=>state.auth)

  const subjectsOptions = subjects.map((item: any) => ({ value: item.subject, label: item.subject }))
  // const classesOptions = classes.map((item:any)=>({value:item.class_code, label:item.class_code}))
  const termsOptions = terms.map((item: any) => ({ value: item, label: item }))
  return (
    <div>
      {/* Add Note */}
      <div className="modal fade" id="note-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Syllabus</h4>
                  </div>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x"></i>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form action="todo">
                    <div className="row">

                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Class</label>
                          <CommonSelect
                            className="select"
                            // classNamePrefix="react-select"
                            options={chooseClass}
                            defaultValue={{
                              label: form.class_code,
                              value: form.class_code,
                            }}
                            handleChange={(newValue: SingleValue<Option>) =>
                              setForm((prev) => ({
                                ...prev,
                                class_code: newValue ? newValue.value : "",
                              }))
                            }
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Term</label>
                          <CommonSelect
                            placeholder="Term"
                            options={termsOptions} 
                            className="select"
                            defaultValue={{
                              value: form.term,
                              label: form.term,
                            }}
                            handleChange={((item: SingleValue<Option>) => {
                              setForm((p) => ({ ...p, term: item?.value || "" }));
                            })}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Subject</label>
                          <CommonSelect
                            placeholder="Subject"
                            options={subjectsOptions}
                            className="select"
                            defaultValue={{
                              value: form.subject,
                              label: form.subject,
                            }}
                            handleChange={((item: SingleValue<Option>) => {
                              setForm((p) => ({ ...p, subject: item?.value || "" }));
                            })}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="input-blocks todo-calendar">
                          <label className="form-label">Weeks</label>
                          <div className="input-groupicon calender-input">
                            <CommonSelect
                              placeholder="Subject"
                              options={WeekOptions}
                              className="select"
                              defaultValue={{
                                value: form.week,
                                label: form.week_label,
                              }}
                              handleChange={((item: SingleValue<Option>) => {
                                setForm((p) => ({ ...p, week: item?.value || "", week_label: item?.label || "" }));
                              })}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Syllabus Title</label>
                          <input type="text" name='title' onChange={handleChange} value={form.title} className="form-control" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3 summer-description-box notes-summernote">
                          <label className="form-label">Descriptions</label>
                          {/* <div id="summernote" /> */}
                          <Editor
                            value={form.content}
                            onTextChange={(e) => setForm((p) => ({ ...p, content: e.htmlValue ?? "" }))}
                            style={{ height: "130px" }}
                          />
                          <p>Maximum 1000 Characters</p>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button onClick={handleSubmit} type="submit" className="btn btn-submit">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Note */}
      {/* Edit Note */}
      <div className="modal fade" id="edit-note-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Syllabus Title</h4>
                  </div>
                  <div className=" edit-note-head d-flex align-items-center">
                    <Link to="#" className="me-2">
                      <span>
                        <Trash2 />
                      </span>
                    </Link>
                    <Link to="#" className="me-2">
                      <span>
                        <Star />
                      </span>
                    </Link>
                    <Link to="#" className="me-2">
                      <span>
                        <Eye />
                      </span>
                    </Link>
                    <button
                      type="button"
                      className="btn-close custom-btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </div>
                </div>
                <div className="modal-body custom-modal-body">
                  <form action="todo">
                    <div className="row">

                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Class</label>
                          <CommonSelect
                            className="select"
                            // classNamePrefix="react-select"
                            options={chooseClass}
                            defaultValue={{
                              label: form.class_code,
                              value: form.class_code,
                            }}
                            handleChange={(newValue: SingleValue<Option>) =>
                              setForm((prev) => ({
                                ...prev,
                                class_code: newValue ? newValue.value : "",
                              }))
                            }
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Term</label>
                          <CommonSelect
                            placeholder="Term"
                            options={termsOptions}
                            className="select"
                            defaultValue={{
                              value: form.term,
                              label: form.term,
                            }}
                            handleChange={((item: SingleValue<Option>) => {
                              setForm((p) => ({ ...p, term: item?.value || "" }));
                            })}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label">Subject</label>
                          <CommonSelect
                            placeholder="Subject"
                            options={subjectsOptions}
                            className="select"
                            defaultValue={{
                              value: form.subject,
                              label: form.subject,
                            }}
                            handleChange={((item: SingleValue<Option>) => {
                              setForm((p) => ({ ...p, subject: item?.value || "" }));
                            })}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="input-blocks todo-calendar">
                          <label className="form-label">Weeks</label>
                          <div className="input-groupicon calender-input">
                            <CommonSelect
                              placeholder="Subject"
                              options={WeekOptions}
                              className="select"
                              defaultValue={{
                                value: form.week,
                                label: form.week_label,
                              }}
                              handleChange={((item: SingleValue<Option>) => {
                                setForm((p) => ({ ...p, week: item?.value || "", week_label: item?.label || "" }));
                              })}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Syllabus Title</label>
                          <input type="text" name='title' onChange={handleChange} value={form.title} className="form-control" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3 summer-description-box notes-summernote">
                          <label className="form-label">Descriptions</label>
                          {/* <div id="summernote" /> */}
                          <Editor
                            value={form.content}
                            onTextChange={(e) => setForm((p) => ({ ...p, content: e.htmlValue ?? "" }))}
                            style={{ height: "130px" }}
                          />
                          <p>Maximum 1000 Characters</p>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button onClick={handleSubmit} type="submit" className="btn btn-submit">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Note */}
      {/* Delete Note */}
      <div className="modal fade" id="delete-note-units">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="delete-popup">
                  <div className="delete-image text-center mx-auto">
                    <ImageWithBasePath
                      src="./assets/img/icons/close-circle.png"
                      alt="Img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="delete-heads">
                    <h4>Are You Sure?</h4>
                    <p>
                      Do you really want to delete this item, This process
                      cannot be undone.
                    </p>
                  </div>
                  <div className="modal-footer-btn delete-footer">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-submit">
                      Delete
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Note */}
      {/* View Note */}
      <div className="modal fade" id="view-note-units">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title edit-page-title">
                    <h4>Syllabus</h4>
                    <p>{selected?.subject}</p>
                  </div>
                  <div className=" edit-noted-head d-flex align-items-center">
                    <Link to="#">
                      <span>
                        <i data-feather="trash-2" />
                      </span>
                    </Link>
                    <Link to="#" className="me-2">
                      <span>
                        <i data-feather="star" />
                      </span>
                    </Link>
                    <button
                      type="button"
                      className="btn-close custom-btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </div>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="edit-head-view">
                        <h6>
                          {selected?.title}
                        </h6>

                        <div dangerouslySetInnerHTML={{ __html: selected?.content }} />
                        <p className="badged high">
                          <i className="fas fa-circle" />
                          {selected?.status}
                        </p>
                      </div>
                      <div className="modal-footer-btn edit-footer-menu">
                        <Link
                          to="#"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /View Note */}
    </div>
  );
};

export default SyllabusModal;
